import IdentifierService from "../Identifier.service";
import type { GTMEventName } from "./gtmConstants";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Payload merged into the object pushed to `window.dataLayer` together with `event`. */
export type PushDataToGTMPayload = Record<string, unknown>;

/**
 * Pushes a structured object into GTM's `dataLayer`.
 * Typically `event` is {@link GTMEvents.DataLayerUpdate}; GTM listens for that event name and reads the fields.
 *
 * Examples:
 * - Link/button: pass `eventCategory: GTMSubEvents.Click`, `eventLabel`: e.g. pageName plus ">INSTALLAPP".
 * - Lead form: pass `eventCategory` as that form’s display name (string).
 *
 * Safe to call from client components only (no-op on server).
 */
export function PushDataToGTM(
  event: GTMEventName,
  payload: PushDataToGTMPayload
): void {
  if (typeof window === "undefined") return;
  const clarityData = IdentifierService.getClarityUserId();
  if (clarityData) {
    payload.clarityUserId = clarityData.clarityUserId;
    payload.claritySessionId = clarityData.claritySessionId;
    payload.clarityProjectId = clarityData.clarityProjectId;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    event,
    ...payload,
  });
}
